import dataModel from '../../models/DataModel';
import CollectionFactory from './CollectionFactory';

export default class CollectionDataSource {
  constructor(collectionType, recordType, recordDescriptor, callBack, name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10) {
    this._name = name;
    this._recordDescriptor = recordDescriptor;
    if (callBack) {
      this._callBack = callBack.bind(this);
    }
    this._collectionType = collectionType;
    this._recordType = recordType;
    this._totalRecords = 0;
// console.log(recordType)
    this.release = this.release.bind(this);
    this._processActionCable = this._processActionCable.bind(this);
    this._processActionCable = this._processActionCable.bind(this);
    this.unregisterUpdatesDeletes = this.unregisterUpdatesDeletes.bind(this);
    this.registerUpdatesDeletes = this.registerUpdatesDeletes.bind(this);

    this._collection = new CollectionFactory(collectionType, name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    this.registerDeregisterCallBacks = this.registerDeregisterCallBacks.bind(this);

    this.registerDeregisterCallBacks(dataModel.actionCableConnector.registerCallback);
  }

  registerDeregisterCallBacks(registerFunction){
    // console.log(registerFunction,this._recordDescriptor)
    if (this._collectionType == 'VendorUsersCollection') {
      registerFunction(this._processActionCable, ['deleteVendorCompany'], null, this._recordDescriptor);
    }
    else if (this._collectionType == 'TasksAssignedCollection') {
      registerFunction(this._processActionCable, ['updateTask'], null, this._recordDescriptor);
    }
    if (this._recordType == 'User') {
      registerFunction(this._processActionCable, ['newVendorUser'], null, this._recordDescriptor);
    }
    else if (this._recordType == 'Project') {
      try {
        registerFunction(this._processActionCable,
          ['updateProjectMemberAssignments', 'updateTaskAssignments'], [dataModel.usersDAO.currentUser.id], this._recordDescriptor);
        registerFunction(this._processActionCable,
          ['addProject'], null, this._recordDescriptor);
      } catch (e) {
        window.location.reload(false);
      }
    }
    else if (this._recordType == 'Company') {
      registerFunction(this._processActionCable, ['newVendorCompany', 'deleteVendorCompany']);
    }
    registerFunction(this._processActionCable, ['new' + this._recordType, 'create' + this._recordType], null, this._recordDescriptor);
  }

  unregisterUpdatesDeletes(ids) {
    if (this._fetchedCollection) {
      dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['update' + this._recordType, 'delete' + this._recordType], this._fetchedCollection.ids);
      if (this._recordType == 'User') {
        dataModel.actionCableConnector.unregisterCallback(this._processActionCable, ['deactivateUser'], this._fetchedCollection.ids, null, this._recordDescriptor);
      }
    }
  }

  registerUpdatesDeletes(ids) {
    if (this._fetchedCollection) {
      dataModel.actionCableConnector.registerCallback(this._processActionCable, ['update' + this._recordType, 'delete' + this._recordType], this._fetchedCollection.ids, this._recordDescriptor);
      if (this._recordType == 'User') {
        dataModel.actionCableConnector.registerCallback(this._processActionCable, ['deactivateUser'], this._fetchedCollection.ids, this._recordDescriptor);
      }
    }
  }

  release() {
    // clear search string on the instance only so we don't invalidate the cache (NEEDS_SYNC) on unmount.
    this._released = true;
    if (this._collection) {
      this._collection._searchString = null;
    }
    this.registerDeregisterCallBacks(dataModel.actionCableConnector.unregisterCallback);
    this.unregisterUpdatesDeletes();
  }

  _processActionCable(fetchedData, acData) {
    if (!this._released) {
      if (this._collection.processItemActionCable) {
        this._collection.processItemActionCable(fetchedData, acData, this._recordDescriptor).then(fetchedCollection => {
          if (fetchedCollection) {
            this.unregisterUpdatesDeletes();
          }

          if (!this._released && fetchedCollection) {
            this._totalRecords = fetchedCollection.totalRecords;

            this._fetchedCollection = fetchedCollection;
            this.registerUpdatesDeletes();
            this._callBack && this._callBack(fetchedCollection, null, acData, fetchedData);
            return fetchedCollection;
          }
        });
      }
      else {
        if (this._fetchAction) {
          return this._collection[this._fetchAction](this._params.param1, this._params.param2, this._params.param3, this._params.param4, this._params.param5, this._params.param6, this._params.param7, this._params.param8).then(fetchedCollection => {
            this.unregisterUpdatesDeletes();
            if (!this._released && fetchedCollection) {
              this._totalRecords = fetchedCollection.totalRecords;
              this._fetchedCollection = fetchedCollection;
              this.registerUpdatesDeletes();
              this._callBack && this._callBack(fetchedCollection, this._fetchAction, acData, fetchedData);
              return fetchedCollection;
            }
          });
        }
        else {
          this._collection.fetchCurrent(true, { clear: true, recordDescriptor: this._recordDescriptor }, fetchedCollection => {
          }).then(fetchedCollection => {
            this.unregisterUpdatesDeletes();
            if (!this._released && fetchedCollection) {
              this._totalRecords = fetchedCollection.totalRecords;
              this._fetchedCollection = fetchedCollection;
              this.registerUpdatesDeletes();
              this._callBack && this._callBack(fetchedCollection, null, acData, fetchedData);
            }
          });
        }
      }
    }
  }

  next(action) {
    if (!this._released) {
      return this._collection.fetchNext(null, { recordDescriptor: this._recordDescriptor }, fetchedCollection => {
        this._callBack && this._callBack(fetchedCollection, 'prefetch');
      }).then(fetchedCollection => {
        this.unregisterUpdatesDeletes();
        if (!this._released && fetchedCollection) {
          this._totalRecords = fetchedCollection.totalRecords;

          this._fetchedCollection = fetchedCollection;
          this.registerUpdatesDeletes();
          this._callBack && this._callBack(fetchedCollection, action);
          return fetchedCollection;
        }
      });
    }
  }

  current(action, force, checkArrays) {
    if (!this._released) {
      return this._collection.fetchCurrent(true, { checkArrays, force, clear: true, recordDescriptor: this._recordDescriptor }, fetchedCollection => {
        this._callBack && this._callBack(fetchedCollection, 'prefetch');
      }).then(fetchedCollection => {
        this.unregisterUpdatesDeletes();
        if (!this._released && fetchedCollection) {
          this._totalRecords = fetchedCollection.totalRecords;
          this._fetchedCollection = fetchedCollection;
          this.registerUpdatesDeletes();
          this._callBack && this._callBack(fetchedCollection, action);
          return fetchedCollection;
        }
      });
    }
  }

  all(action, force, checkArrays) {
    if (!this._released) {
      return this._collection.fetchCurrent(false, { checkArrays, force, clear: true, recordDescriptor: this._recordDescriptor }, fetchedCollection => {
        this._callBack && this._callBack(fetchedCollection, 'prefetch');
      }).then(fetchedCollection => {
        this.unregisterUpdatesDeletes();
        if (!this._released && fetchedCollection) {
          this._totalRecords = fetchedCollection.totalRecords;
          this._fetchedCollection = fetchedCollection;
          this.registerUpdatesDeletes();
          this._callBack && this._callBack(fetchedCollection, action);
          return fetchedCollection;
        }
      });
    }
  }

  performFetchAction(fetchAction, param1, param2, param3, param4, param5, param6, param7, param8) {
    if (!this._released) {
      this._fetchAction = fetchAction;
      this._params = { param1, param2, param3, param4, param5, param6, param7, param8 };
      return this._collection[fetchAction](param1, param2, param3, param4, param5, param6, param7, param8).then(fetchedCollection => {
        this.unregisterUpdatesDeletes();
        if (!this._released && fetchedCollection) {
          this._totalRecords = fetchedCollection.totalRecords;
          this._fetchedCollection = fetchedCollection;
          this.registerUpdatesDeletes();
          this._callBack && this._callBack(fetchedCollection, fetchAction);
          return fetchedCollection;
        }
      });
    }
  }

  get totalRecords() {
    return this._totalRecords;
  }

  set project_id(projectId) {
    this._collection.project_id = projectId;
  }

  set searchString(searchStr) {
    this._collection.searchString = searchStr;
  }

  get searchString() {
    return this._collection.searchString;
  }

  set filter(f) {
    this._collection.filter = f;
  }

  get filter() {
    return this._collection.filter;
  }

  set perPage(value) {
    this._collection.perPage = value;
  }

  set page(value) {
    this._collection.page = value;
  }

}



// WEBPACK FOOTER //
// ./src/dao/DataSource/CollectionDataSource.js